__turbopack_context__.v({
  "eyebrow": "GameDevelopmentServicesCardSection-module__dlpkBa__eyebrow",
  "heading": "GameDevelopmentServicesCardSection-module__dlpkBa__heading",
  "section": "GameDevelopmentServicesCardSection-module__dlpkBa__section",
  "title": "GameDevelopmentServicesCardSection-module__dlpkBa__title",
});
